export default __webpack_public_path__ + "static/media/Layer_4@2x.28e28bb2.png";